<h2>E-Filing</h2>
<p-confirmDialog
    key="allErrors"
    appendTo="body"
    [style]="{ maxWidth: '95vw' }" />
<p-confirmDialog
    key="someErrors"
    appendTo="body"
    [style]="{ maxWidth: '95vw' }" />
<p-confirmDialog
    key="submissionSummary"
    appendTo="body"
    [style]="{ maxWidth: '95vw' }" />
<p-confirmDialog
    key="errorResponse"
    appendTo="body"
    [style]="{ maxWidth: '95vw' }"></p-confirmDialog>
<p-confirmDialog
    #twoBtn
    key="submissionSummaryTwoButton"
    appendTo="body"
    [style]="{ width: '50vw', maxWidth: '95vw' }">
    <ng-template #footer>
        <div style="display: flex; justify-content: space-between; width: 100%">
            <p-button
                label="Cancel"
                severity="secondary"
                [text]="true"
                (click)="twoBtn.onReject()" />
            <div style="display: flex; gap: 0.5rem">
                <p-button
                    label='Submit Invoice ("Saved")'
                    outlined="true"
                    (onClick)="submitInvoiceDestinationOverride('save')" />
                <p-button
                    label='Submit Invoice ("Submit")'
                    (click)="submitInvoiceDestinationOverride('submit')" />
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

@if (showBuyerTestingBanner) {
    <p-message styleClass="w-full mb-3 invoice-banner--warning">
        {{ parentCompanyLabel }} is currently in test mode.
    </p-message>
}

<app-e-filing-filters
    (exportTable)="exportToExcel($event)"
    (filtersApplied)="onFiltersApplied($event)"
    (unselectAll)="onUnselectAll()"
    (refreshInvoices)="onRefresh()"
    (submitInvoices)="invoicesSubmissionHandler()"
    [isLoading]="isProcessTableLoading"
    [refreshLoading]="isInvoiceRefreshing"
    [invoices]="data"></app-e-filing-filters>

<!--E-Filing Table-->
@if (!parentCompany) {
    <div class="no-company-selected">
        <i class="pi pi-building"></i>
        <p>Select a parent company above to load invoices.</p>
    </div>
}

<div
    [class.no-data]="isProcessTableLoading"
    [hidden]="!parentCompany"
    class="e-filing-table">
    @if (isProcessTableLoading) {
        <div class="spinner-container">
            <app-embark-spinner
                [size]="'3'"
                [strokeWidth]="'6'"></app-embark-spinner>
        </div>
    }
    @if (!isProcessTableLoading) {
        <p-table
            #dt
            (onPage)="handlePaginatorChange($event)"
            [paginatorDropdownAppendTo]="'body'"
            [paginator]="true"
            [resizableColumns]="true"
            [rowsPerPageOptions]="[25, 50, 100]"
            [rows]="paginatorRows"
            [scrollable]="true"
            [sortMode]="'multiple'"
            [value]="filteredData"
            [multiSortMeta]="defaultSortMeta">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 40px; text-align: center">
                        <p-checkbox
                            (onChange)="onSelectAll($event)"
                            [(ngModel)]="allSelected"
                            [binary]="true"
                            inputId="'select-all'"></p-checkbox>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="po">
                        PO
                        <p-sortIcon field="po"></p-sortIcon>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="ticketNumber"
                        style="max-width: 115px">
                        SO
                        <p-sortIcon field="ticketNumber"></p-sortIcon>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="invoiceId">
                        Invoice
                        <p-sortIcon field="invoiceId"></p-sortIcon>
                    </th>
                    <th
                        class="col-3 font-bold"
                        pSortableColumn="name"
                        style="width: 200px">
                        Client
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>

                    <!--					todo: this can be retooled to submitted by-->
                    <!--					<th-->
                    <!--						class="col-1 font-bold"-->
                    <!--						pSortableColumn="assignedTo"-->
                    <!--						style="max-width: 150px">-->
                    <!--						Assigned To-->
                    <!--						<p-sortIcon field="assignedTo"></p-sortIcon>-->
                    <!--					</th>-->

                    <th
                        class="col-1 font-bold"
                        pSortableColumn="requisitioner"
                        style="max-width: 150px">
                        Requisitioner
                        <p-sortIcon field="requisitioner"></p-sortIcon>
                    </th>

                    <th
                        class="col-1 font-bold"
                        pSortableColumn="dateObject">
                        Invoice Date
                        <p-sortIcon field="dateObject"></p-sortIcon>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="amount">
                        Amount
                        <p-sortIcon field="amount"></p-sortIcon>
                    </th>

                    <!--					removed until saved searches load non-open invoices -->
                    <!--					<th-->
                    <!--						class="col-1 font-bold"-->
                    <!--						pSortableColumn="nsStatus">-->
                    <!--						NS Status-->
                    <!--						<p-sortIcon field="status"></p-sortIcon>-->
                    <!--					</th>-->

                    <th
                        class="col-1 font-bold"
                        pSortableColumn="otStatus">
                        OT Status
                        <p-sortIcon field="otStatus"></p-sortIcon>
                    </th>

                    <th
                        class="col-1 font-bold"
                        pSortableColumn="oiStatus">
                        OI Status
                        <p-sortIcon field="oiStatus"></p-sortIcon>
                    </th>

                    <th
                        class="col-1 font-bold"
                        pSortableColumn="errorStatus"
                        style="word-wrap: break-word">
                        Validation
                        <p-sortIcon field="errorStatus"></p-sortIcon>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="submissionErrorStatus"
                        style="word-wrap: break-word">
                        Submission
                        <p-sortIcon field="submissionErrorStatus"></p-sortIcon>
                    </th>
                    <th
                        class="col-1 font-bold"
                        pSortableColumn="ticketComplianceStatus"
                        style="word-wrap: break-word">
                        Ticket Compliance
                        <p-sortIcon field="ticketComplianceStatus"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template
                let-invoice
                pTemplate="body">
                <tr
                    (click)="viewInvoice(invoice)"
                    [class.hover-blue]="!invoice.isSubmitting"
                    [class.pointer]="!invoice.isSubmitting"
                    class="dashboard-row">
                    @if (invoice.canSubmit) {
                        @if (!invoice.isSubmitting) {
                            <td
                                (click)="$event.stopPropagation()"
                                class="e-filing-table-cell"
                                style="max-width: 50px">
                                <p-checkbox
                                    (onChange)="onInvoiceSelectionChange($event, invoice)"
                                    [(ngModel)]="invoice.selected"
                                    [binary]="true"
                                    [inputId]="'invoice-' + invoice.id"></p-checkbox>
                            </td>
                        } @else {
                            <td>
                                <app-embark-spinner
                                    [size]="'1'"
                                    [strokeWidth]="'6'"></app-embark-spinner>
                            </td>
                        }
                    } @else {
                        <td></td>
                    }
                    <td
                        [pTooltip]="invoice.po"
                        [tooltipPosition]="'top'"
                        class="e-filing-table-cell"
                        style="max-width: 150px">
                        {{ invoice.po }}
                    </td>

                    <td style="max-width: 115px">
                        <a
                            (click)="$event.stopPropagation()"
                            [style]="{ color: 'inherit' }"
                            href="https://{{
                                environment.netSuiteInstance.subdomain
                            }}.app.netsuite.com/app/accounting/transactions/salesord.nl?id={{
                                invoice?.salesOrderId
                            }}&whence="
                            target="_blank">
                            {{ invoice.ticketNumber }}
                        </a>
                    </td>

                    <td>
                        <a
                            (click)="$event.stopPropagation()"
                            [style]="{ color: 'inherit' }"
                            href="https://{{
                                environment.netSuiteInstance.subdomain
                            }}.app.netsuite.com/app/accounting/transactions/custinvc.nl?id={{
                                invoice?.internalId
                            }}&whence="
                            target="_blank">
                            {{ invoice.invoiceId }}
                        </a>
                    </td>

                    <td
                        [pTooltip]="invoice.name"
                        [tooltipPosition]="'top'"
                        class="e-filing-table-cell"
                        style="max-width: 300px">
                        {{ invoice.name }}
                    </td>

                    <!--					<td>{{ invoice.assignedTo }}</td>-->

                    <td
                        [title]="invoice.requisitioner | decodeHtml"
                        class="field-approver">
                        {{ invoice.requisitioner | decodeHtml }}
                    </td>

                    <td>{{ invoice.dateObject | date: "MM/dd/yyyy" }}</td>

                    <td>{{ invoice.amount | currency }}</td>

                    <!--					removed until non-open invoices are loaded into application-->
                    <!--					<td>-->
                    <!--                        <span-->
                    <!--							[class]="'status-' + invoice.nsStatus.toLowerCase()"-->
                    <!--	                        class="embark-badge">-->
                    <!--                            {{ invoice.nsStatus }}-->
                    <!--                        </span>-->
                    <!--					</td>-->

                    <td>
                        @if (invoice.otDisplayStatus) {
                            @if (invoice.openTicketUrl) {
                                <span
                                    (click)="$event.stopPropagation(); openTicketUrl(invoice)"
                                    [class]="'status-' + (invoice.otStatus ?? '').toLowerCase()"
                                    [class.pointer]="!!invoice.openTicketUrl"
                                    class="embark-badge">
                                    {{ invoice.otDisplayStatus }}
                                </span>
                            } @else {
                                <span
                                    [class]="'status-' + (invoice.otStatus ?? '').toLowerCase()"
                                    class="embark-badge">
                                    {{ invoice.otDisplayStatus }}
                                </span>
                            }
                        } @else {
                            <span class="status-open embark-badge">N/A</span>
                        }
                    </td>

                    <td>
                        @if (invoice.oiDisplayStatus) {
                            @if (invoice.openInvoiceUrl) {
                                <span
                                    (click)="$event.stopPropagation(); openInvoiceUrl(invoice)"
                                    [class]="'status-' + (invoice.oiStatus ?? '').toLowerCase()"
                                    [class.pointer]="!!invoice.openInvoiceUrl"
                                    class="embark-badge">
                                    {{ invoice.oiDisplayStatus }}
                                </span>
                            } @else {
                                <span
                                    [class]="'status-' + (invoice.oiStatus ?? '').toLowerCase()"
                                    [class.pointer]="!!invoice.openInvoiceUrl"
                                    class="embark-badge">
                                    {{ invoice.oiDisplayStatus }}
                                </span>
                            }
                        } @else {
                            <span class="status-open embark-badge">N/A</span>
                        }
                    </td>

                    <td>
                        @if (invoice.errors?.length) {
                            <span
                                [pTooltip]="invoice.errors!.map((e) => e.message).join('; ')"
                                [tooltipPosition]="'top'">
                                <i
                                    class="pi pi-times-circle"
                                    style="color: red; margin-right: 4px"></i>
                            </span>
                        }
                        @if (invoice.warnings?.length) {
                            <span
                                [pTooltip]="invoice.warnings!.map((e) => e.message).join('; ')"
                                [tooltipPosition]="'top'">
                                <i
                                    class="pi pi-exclamation-triangle"
                                    style="color: orange; margin-right: 4px"></i>
                            </span>
                        }
                        @if (!invoice.errors?.length && !invoice.warnings?.length) {
                            <span
                                pTooltip="Ready for submission"
                                [tooltipPosition]="'top'">
                                <i
                                    class="pi pi-info-circle"
                                    style="color: green; font-size: 1.1rem"></i>
                            </span>
                        }
                    </td>
                    <td>
                        @if (!invoice.submissionErrors?.length && !invoice.submissionWarnings?.length) {
                            <span
                                pTooltip="All invoice actions have completed successfully"
                                [tooltipPosition]="'top'">
                                <i
                                    class="pi pi-info-circle"
                                    style="font-size: 1.1rem"></i>
                            </span>
                        } @else {
                            @if (invoice.submissionErrors?.length) {
                                <span
                                    [pTooltip]="invoice.submissionErrors!.map((e) => e.message).join('; ')"
                                    tooltipPosition="top">
                                    <i
                                        class="pi pi-times-circle"
                                        style="color: red; margin-right: 4px"></i>
                                </span>
                            }

                            @if (invoice.submissionWarnings?.length) {
                                <span
                                    [pTooltip]="invoice.submissionWarnings!.map((e) => e.message).join('; ')"
                                    tooltipPosition="top">
                                    <i
                                        class="pi pi-exclamation-triangle"
                                        style="color: orange; margin-right: 4px"></i>
                                </span>
                            }
                        }
                    </td>

                    <td>
                        @if (invoice.ticketComplianceErrors?.length) {
                            <span
                                [pTooltip]="ticketComplianceTooltip(invoice)"
                                tooltipPosition="top">
                                <i
                                    class="pi pi-exclamation-triangle"
                                    style="color: orange; margin-right: 4px"></i>
                            </span>
                        }
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }
</div>
